/**
 * Параметры GET /api/kraken/ports/all «Сетевых портов» по поводу запроса (DF83).
 *
 * fresh=1 — заход на вкладку и возврат на вкладку браузера: бэкенд сперва делает выборку с серверов,
 * если общему снимку больше 15 с. refresh=1 — кнопка «Обновить» и обновление после правки: выборка,
 * начатая после запроса. Выборка не легла за 1,5 с — ответ с последним известным и заголовком
 * X-Ports-Pending-After: страница перечитывает с after=… (ждёт выборку, новую не начинает).
 * Фоновое обновление раз в 20 с — без флагов: что есть, без ожидания.
 */
export function portsAllParams({ refresh = false, fresh = false, after = null } = {}) {
  return {
    page: 1,
    perpage: 10000,
    ...(refresh ? { refresh: 1 } : {}),
    ...(fresh ? { fresh: 1 } : {}),
    ...(after != null ? { after } : {}),
  };
}

/** Делить один идущий запрос можно только фоновым: заход, «Обновить» и перечитывание ждут свою выборку. */
export function sharesInFlightPortsRequest({ refresh = false, fresh = false, after = null } = {}) {
  return !refresh && !fresh && after == null;
}
